import React from 'react'
import c from 'classnames'
import set from 'lodash/set'
import get from 'lodash/get'

import Loading from 'discada/dist/Loading'
import Button from 'discada/dist/Button'

import './Config.scss'

export function ConfigWrapper({ className, header, children, loading }) {
  return (
    <div className={c('config-wrapper', className, { loading })}>
      {header}
      <div className="config-body">{loading ? <Loading /> : children}</div>
    </div>
  )
}

export function ConfigHeader({ className, title, children }) {
  return (
    <div className={c('config-header', className)}>
      <div>
        <h2>{title}</h2>
        <div className="config-controls">{children}</div>
      </div>
    </div>
  )
}

export function ConfigSubmitSet({
  onSubmit,
  onClone,
  onDelete,
  onCancel,
  className,
  errorMessage = '',
}) {
  return (
    <div className={c('config-submit-set', className)}>
      {errorMessage ? (
        <article className={c('message', 'is-danger')}>
          <div className="message-body">
            <h4>
              <strong>Problem saving config:</strong> {errorMessage.toString()}
            </h4>
          </div>
        </article>
      ) : null}
      <div className="config-submit-set-inner">
        {onSubmit && (
          <Button onClick={onSubmit} success icon="save">
            Save Settings
          </Button>
        )}
        {onClone && (
          <Button onClick={onClone} info icon="copy">
            Clone
          </Button>
        )}
        {onDelete && (
          <Button onClick={onDelete} danger icon="trash">
            Delete
          </Button>
        )}
        {onCancel && (
          <Button onClick={onCancel} text>
            Cancel
          </Button>
        )}
      </div>
    </div>
  )
}

export default class Config extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      dirty: false,
      config: this.props.config || {},
      currentQuoteConfigId: this.props.currentQuoteConfigId,
      isLoading: true,
      error: null,
    }

    this.addItem = (collection, starter) => ({ overrideStarter }) => {
      this.setState({
        config: {
          ...this.state.config,
          [collection]: [
            ...get(this.state.config, collection, []),
            overrideStarter || starter,
          ],
        },
      })
    }

    this.removeItem = (collection, needOne) => index => {
      let items = get(this.state.config, collection, [])

      if (items.length === 1 && needOne) return

      items.splice(index, 1)

      this.setState(
        {
          config: {
            ...this.state.config,
            [collection]: items,
          },
        },
        () => this.makeDefault(collection)(get(items, '[0].value')),
      )
    }

    this.editValue = collection => (index, key, val) => {
      let config = { ...(this.state.config || {}) },
        configKey =
          index !== null
            ? `${collection}[${index}].${key}`
            : `${collection}.${key}`

      set(config, configKey, val)

      this.setState({ config })
    }

    this.makeDefault = collection => v => {
      let items = this.state.config[collection].map(item => ({
        ...item,
        default: parseInt(item.value, 10) === parseInt(v, 10),
      }))

      this.setState({
        config: {
          ...this.state.config,
          [collection]: items,
        },
      })
    }
  }

  static getDerivedStateFromProps(newProps, oldState) {
    let config =
      newProps.configId !== oldState.configId
        ? newProps.config
        : { ...newProps.config, ...oldState.config }

    return {
      ...oldState,
      ...newProps,
      config,
      isLoading: newProps.isLoading || newProps.configId !== oldState.configId,
    }
  }
}
